import React from "react";
import { Toaster } from "react-hot-toast";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import Layout from "./components/Layout";
import ProtectedRoute from "./components/ProtectedRoute";
import { AuthProvider } from "./contexts/AuthContext";
import Activites from "./pages/Activites";
import AdminDashboard from "./pages/AdminDashboard";
import AdminParents from "./pages/AdminParents";
import ChangePassword from "./pages/ChangePassword";
import ForgotPassword from "./pages/ForgotPassword";
import Home from "./pages/Home";
import Login from "./pages/Login";
import ParentDashboard from "./pages/ParentDashboard";
import Profile from "./pages/Profile";
import QRScanner from "./pages/QRScanner";
import Recompenses from "./pages/Recompenses";
import Register from "./pages/Register";
import ResetPassword from "./pages/ResetPassword";
import Statistiques from "./pages/Statistiques";
import ValidateQR from "./pages/ValidateQR";
import ValidationSuccess from "./pages/ValidationSuccess";

// Composant wrapper pour AuthProvider avec Router
function AppWithRouter() {
  return (
    <Router>
      <AuthProvider>
        <div className="min-h-screen bg-gray-50">
          <Toaster position="top-right" />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/validate" element={<ValidateQR />} />
            <Route
              path="/validate/success/:tamponId"
              element={<ValidationSuccess />}
            />
            <Route
              path="/app"
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Navigate to="/app/dashboard" replace />} />
              <Route path="dashboard" element={<ParentDashboard />} />
              <Route
                path="admin"
                element={
                  <ProtectedRoute requiredRole="admin">
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="admin/parents"
                element={
                  <ProtectedRoute requiredRole="admin">
                    <AdminParents />
                  </ProtectedRoute>
                }
              />
              <Route
                path="qr-scanner"
                element={
                  <ProtectedRoute requiredRole="admin">
                    <QRScanner />
                  </ProtectedRoute>
                }
              />
              <Route
                path="activites"
                element={
                  <ProtectedRoute requiredRole="admin">
                    <Activites />
                  </ProtectedRoute>
                }
              />
              <Route
                path="recompenses"
                element={
                  <ProtectedRoute requiredRole="admin">
                    <Recompenses />
                  </ProtectedRoute>
                }
              />
              <Route
                path="statistiques"
                element={
                  <ProtectedRoute requiredRole="admin">
                    <Statistiques />
                  </ProtectedRoute>
                }
              />
              <Route path="profile" element={<Profile />} />
              <Route path="change-password" element={<ChangePassword />} />
            </Route>
          </Routes>
        </div>
      </AuthProvider>
    </Router>
  );
}

function App() {
  return <AppWithRouter />;
}

export default App;
